import { useState } from "react";
import { Typography, Modal, Button, MultiEmailInput, Loading } from "@/components/atoms";
import { useBulkInviteDriverMutation } from "@/redux/apis/driver/driverApi";
import { addToast } from "@/utils";

interface InviteDriversModalProps {
  open: boolean;
  onClose: () => void;
}

export const InviteDriversModal = ({ open, onClose }: InviteDriversModalProps) => {
  const [emails, setEmails] = useState<string[]>([]);
  const [bulkInviteDriver, { isLoading }] = useBulkInviteDriverMutation();

  const handleInvite = async () => {
    if (emails.length === 0) {
      addToast("info", "Please enter at least one email address");
      return;
    }

    try {
      await bulkInviteDriver({ emails }).unwrap();
      addToast("success", `Invitation sent to ${emails.length} driver(s)`);
      setEmails([]);
      onClose();
    } catch (error) {
      addToast("danger", "Failed to send invitations. Please try again.");
    }
  };

  return (
    <Modal open={open} onClose={onClose} className="relative w-[85vw] md:w-[550px] lg:w-[600px]">
      {isLoading && <Loading />}
      <div className="flex flex-col">
        <div className="flex flex-col gap-y-2">
          <Typography variant="title">Invite Driver</Typography>
          <Typography variant="paragraph" className="text-neutral-dark-gray">
            Send an invite for the driver to download the app and set up their account
          </Typography>
        </div>

        <div className="mt-5 flex flex-col gap-y-1">
          <Typography variant="action" className="text-neutral-dark-gray">
            Driver Email(s)
          </Typography>
          <MultiEmailInput emails={emails} onChange={setEmails} />
          <Typography variant="paragraph" className="text-neutral-silver-gray">
            You can enter multiple email addresses separated by commas
          </Typography>
        </div>

        <div className="mt-10 flex justify-end gap-x-3">
          <Button variant="secondary" size="lg" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="primary" size="lg" onClick={handleInvite} disabled={emails.length === 0 || isLoading}>
            Invite Driver(s)
          </Button>
        </div>
      </div>
    </Modal>
  );
};
